import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=4c5becb6&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=4c5becb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5becb6",
  null
  
)

export default component.exports